<template>
  <div id="divLogin">
    <div id="BGImages">
      <img src="../assets/images/BGImages/BG1.jpg" />
    </div>
    <div
      style="
        display: flex;
        justify-content: center;
        width: 100%;
        flex-wrap: wrap;
        top: 50px;
        postiion: relative;
      "
      v-if="isBrowserCompatibility"
    >
      <div
        v-if="!hideBg"
        id="CoLogoBlock"
        style="display:flex;flex-direction:row;align-items:center;jsutify-content:center:"
      >
        <img
          class="imgHeight"
          src="../assets/Login/Logoa.png"
          style="min-height: 160"
        />
      </div>
      <div
        id="LoginBlock"
        style="color: Black; min-height: 160px"
        v-if="!hideBg"
      >
        <div class="Flex_Table Wrap" DefaultButton="btnTokenAuth">
          <div class="Flex_Row" style="padding-bottom: 5px">
            <div
              class="Flex_Cell Resend"
              width="85%"
              align="center"
              style="font-size: 20px"
            >
              <b>
                <span>
                  <u> Login for Nominations</u>
                </span>
              </b>
            </div>
            <div
              class="Flex_Cell"
              style="
                text-align: right;
                padding-bottom: 5px;
                color: white;
                font-weight: bold;
                text-shadow: 1px 1px 2px #000, 0 0 25px #151515, 0 0 5px #131313;
              "
            >
              <b
                ><span style="text-align: right" title="Download User Manual">
                  <u><a @click="downloadSample()">User Manual</a></u></span
                ></b
              >
            </div>
          </div>
          <div class="Flex_Row" style="padding-bottom: 5px">
            <div
              class="Flex_Cell"
              width="50%"
              style="padding-right: 5px"
              v-if="loginTypeID == 1 && loginWithOTP == true"
            >
              <span class="DataIcon glyphicons user"></span>
              <input
                type="button"
                class="Button"
                id="btnTokenAuth"
                @click="sendOTP()"
                style="margin: 0px; font-size: smaller"
                value="GET OTP"
              />
              <input
                type="text"
                id="txtLogin"
                v-model="loginName"
                placeholder="Enter Email / Mobile"
                autocomplete="off"
                readonly
                onfocus="this.removeAttribute('readonly');"
              />
            </div>
            <div
              class="Flex_Cell"
              v-if="
                (loginTypeID == 3 && loginWithPass == true) || loginTypeID == 2
              "
              width="34%"
              style="padding-right: 5px"
            >
              <span class="DataIcon glyphicons user"></span>
              <input
                type="text"
                id="txtLogin"
                v-model="loginName"
                placeholder="Enter Email / Mobile"
                autocomplete="off"
                readonly
                onfocus="this.removeAttribute('readonly');"
              />
            </div>
            <div
              class="Flex_Cell"
              style="padding-right: 5px"
              width="33%"
              v-if="loginTypeID == 3 && loginWithPass == true"
            >
              <span
                class="DataIcon glyphicons keys"
                style="color: black"
              ></span>
              <input
                type="password"
                id="txtPassword"
                name="txtPassword"
                placeholder="Enter Password"
                v-model="loginPassword"
                autocomplete="off"
                readonly
                onfocus="this.removeAttribute('readonly');"
              />
            </div>
            <div
              class="Flex_Cell"
              style="padding-right: 5px"
              width="33%"
              v-if="loginTypeID == 2"
            >
              <span
                class="DataIcon glyphicons phone"
                style="color: black"
              ></span>
              <input
                type="button"
                class="resendBtn"
                id="btnTokenAuth"
                @click="generateForgotOTP(2)"
                style="margin: 0px; font-size: smaller"
                v-if="isDisabled == false"
                value="RESEND"
              />
              <input
                type="password"
                id="txtOTP"
                name="txtOTP"
                placeholder="Enter OTP"
                v-model="loginOTP"
                v-on:keyup.enter="authenticateUser(loginTypeID)"
                maxlength="6"
                autocomplete="off"
                readonly
                regExp="([0-9])*"
                onfocus="this.removeAttribute('readonly');"
              />
              <div
                class="Flex_Row Resend"
                valign="middle"
                align="right"
                v-if="loginTypeID == 2 && OtpCaptchaID == 0"
              >
                <span>
                  <b
                    >Resend OTP after
                    {{
                      this.minutesLeft +
                      ":" +
                      (this.secondsLeft > 9
                        ? this.secondsLeft
                        : "0" + this.secondsLeft)
                    }}</b
                  >
                </span>
              </div>
            </div>
            <div class="Flex_Cell" width="33%" v-if="OtpCaptchaID == 1">
              <span
                class="DataIcon glyphicons refresh"
                style="cursor: pointer"
                v-on:click="generateCaptcha(4, 80, 18)"
              ></span>
              <img
                id="imgCaptchaForResendOTP"
                style="border: 0px solid #000; border-radius: 12px"
                class="Captcha2"
              />
              <input
                type="text"
                v-model="captchaValueforResendOTP"
                v-on:keyup.enter="generateForgotOTP(2)"
                placeholder="Captcha"
                maxlength="6"
              />
            </div>
            <div
              class="Flex_Cell"
              width="33%"
              v-if="loginTypeID == 3 && loginWithPass == true"
            >
              <span
                class="DataIcon glyphicons refresh"
                style="cursor: pointer"
                v-on:click="generateCaptcha(7, 210, 40)"
              ></span>
              <img
                id="imgCaptchaForLogin"
                style="border: 0px solid #000; border-radius: 12px"
                class="Captcha1"
              />
              <input
                type="text"
                v-model="captchaValueforLogin"
                v-on:keyup.enter="authenticateUser(loginTypeID)"
                placeholder="Captcha"
                maxlength="6"
              />
            </div>
            <div
              class="Flex_Cell"
              width="50%"
              v-if="loginTypeID == 1 && loginWithOTP == true"
            >
              <span
                class="DataIcon glyphicons refresh"
                style="cursor: pointer"
                v-on:click="generateCaptcha(3, 100, 17)"
              ></span>
              <img
                id="imgCaptchaForGetOTP"
                style="border: 0px solid #000; border-radius: 12px"
                class="Captcha"
              />
              <input
                type="text"
                v-model="captchaValueforGetOTP"
                v-on:keyup.enter="sendOTP()"
                placeholder="Captcha"
                maxlength="6"
              />
            </div>
          </div>
          <div
            class="Flex_Row"
            valign="middle"
            align="center"
            v-if="loginTypeID == 1 && loginWithOTP == true"
            style="
              padding-bottom: 5px;
              color: white;
              font-weight: bold;
              text-shadow: 1px 1px 2px #000, 0 0 25px #151515, 0 0 5px #131313;
            "
          >
            <span v-if="loginTypeID == 1 && loginWithPass == true"
              >Login Using
              <u
                ><a @click="changeLoginType(1, loginWithOTP, loginWithPass)"
                  >Password</a
                ></u
              ></span
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <!-- <span style="font-size: 18px; color: yellow">
              <u><a @click="signUp()">Sign up for Nominations</a></u></span
            ><br /><br /><br /> -->
            <span style="font-size: 18px; color: yellow">
              <u><a @click="signUp()">Create New Account</a></u></span
            ><br /><br /><br />
          </div>
          <div
            class="Flex_Row"
            v-if="loginTypeID == 2"
            valign="middle"
            align="right"
            style="padding-bottom: 5px; color: rgb(0 4 126)"
          >
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="top: 2px"
            >
              <input
                type="button"
                id="btnTokenAuth"
                value="Login"
                v-on:click="authenticateUser(loginTypeID)"
              />
              <input type="button" value="Cancel" v-on:click="clearPage()" />
            </div>
          </div>
          <div
            class="Flex_Row"
            v-if="loginTypeID == 3 && loginWithPass == true"
            valign="middle"
            align="center"
            style="
              padding-bottom: 5px;
              color: white;
              font-weight: bold;
              text-shadow: 1px 1px 2px #000, 0 0 25px #151515, 0 0 5px #131313;
            "
          >
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 80%; top: 0px"
            >
              <b>
                <span v-if="loginTypeID == 3 && loginWithOTP == true"
                  >Login Using
                  <u
                    ><a @click="changeLoginType(2, loginWithOTP, loginWithPass)"
                      >OTP</a
                    ></u
                  ></span
                ></b
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b>
                <span>
                  <u><a @click="forgetPasswordView()">Forgot Password</a></u>
                </span> </b
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

              <b>
                <span>
                  <u> <a @click="changePasswordView()">Change Password</a> </u>
                </span> </b
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <!-- <b><span style="font-size: 18px; color: yellow">
                  <u><a @click="signUp()">Sign up for Nominations</a></u></span
                ></b
              > -->

              <span style="font-size: 18px; color: yellow">
                <u><a @click="signUp()">Create New Account</a></u></span
              >
              <br /><br /><br />
            </div>
            <div
              class="Flex_Cell"
              align="right"
              valign="middle"
              style="width: 20%; top: 0px"
            >
              <input
                type="button"
                id="btnTokenAuth"
                value="Login"
                v-on:click="authenticateUser(loginTypeID)"
              />
            </div>
          </div>
          <div class="Flex_Row" v-if="!isAdvertisementValid">
            <div class="Flex_Cell" align="center">
              <span style="font-size: medium; color: red; font-weight: bold">
                Online application process has ended. Only applicant's who have
                paid can login.
              </span>
            </div>
          </div>
        </div>
      </div>
      <div id="CreateLoginBlock" v-if="createNewAccountdiv">
        <div class="Flex_Table CreateLoginBlockHeader">
          <div class="Flex_Row">
            <div class="Flex_Cell" width="80%">
              <span>Registration Form</span>
            </div>
          </div>
        </div>
        <div class="CreateLoginContent">
          <!-- <div class="Flex_Table">
            <div class="Flex_Row">
              <div class="Flex_Cell">
                <div class="Flex_Table Instruction">
                  <div class="Flex_Row">
                    <div class="Flex_Cell">
                      <span style="font-size: medium; font-weight: bold">
                        Guidelines to fill the application form
                      </span>
                    </div>
                  </div>
                  <div class="Flex_Row instructionRow">
                    <div class="Flex_Cell">
                      <span style="color: Blue; font-weight: bold">1.</span>
                      Candidates are requested to read the instructions
                      carefully before filling up online application. To
                      facilitate the candidates, specimen of application form
                      (including Registration process) is made available on
                      <b>“Candidates”</b> corner on the website
                      <a style="color: blue">www.aocrecruitment.gov.in</a>.
                      Stagewise guidelines to fill online application form are
                      elaborated here.
                    </div>
                  </div>
                  <div class="Flex_Row instructionRow">
                    <div class="Flex_Cell">
                      <span style="color: Blue; font-weight: bold">2.</span>
                      Name and Date of Birth should be as mentioned in
                      Matriculation Certificate or equivalent issued by
                      recognised Education Board.
                    </div>
                  </div>
                  <div class="Flex_Row instructionRow">
                    <div class="Flex_Cell">
                      <span style="color: Blue; font-weight: bold">3.</span>
                      Candidates should note that only the date of birth as
                      recorded in the matriculation, higher secondary
                      examination certificate or an equivalent certificate
                      recognised by State/central board provided on the date of
                      submission of application will be accepted for determining
                      the age eligibility and no subsequent request for its
                      change will be considered or granted.
                    </div>
                  </div>
                  <div class="Flex_Row instructionRow">
                    <div class="Flex_Cell">
                      <span style="color: Blue; font-weight: bold">4.</span>
                      <b> Mobile Number & email ID.</b> Registration process is
                      made by verifying Mobile Number and eMail ID through OTP.
                      All further communication will be made on the Mobile
                      Number and email ID recorded at the time of Registration.
                      Hence, candidates are advised to fill valid mobile number
                      and email ID only and not to change their Mobile Number
                      and email ID.
                    </div>
                  </div>
                  <div class="Flex_Row instructionRow">
                    <div class="Flex_Cell">
                      <span style="color: Blue; font-weight: bold">5.</span>
                      <b> Password.</b> Candidates are advised in their own
                      interest not to share their password.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <div class="Flex_Table Wrap" width="100%">
            <div class="Flex_Row">
              <div class="Flex_Cell" width="30%"></div>
              <div class="Flex_Cell" width="4%"></div>
              <div class="Flex_Cell" width="30%"></div>
              <div class="Flex_Cell" width="4%"></div>
              <div class="Flex_Cell" width="30%"></div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell" width="30%">
                <span>User Type</span>
                <span style="color: red; font-weight: bold">*</span>
                <select
                  class="CreateAccount"
                  id="ddlUserType"
                  v-model="userTypeID"
                >
                  <option
                    v-for="m in userTypeList"
                    :key="m.loginTypeID"
                    v-bind:value="m.loginTypeID"
                  >
                    {{ m.loginTypeName }}
                  </option>
                </select>
              </div>
              <div class="Flex_Cell" width="4%"></div>
              <div class="Flex_Cell" width="30%">
                <span>Mobile No.</span>
                <span style="color: red; font-weight: bold">*</span>
                <div class="Flex_Table">
                  <div class="Flex_Row">
                    <div class="Flex_Cell" width="10%">
                      <AcceptInput
                        style="padding-left:0 padding-right:0"
                        ref="MobileNoCC"
                        type="textbox"
                        v-model="MobileNoCC"
                        :isRequired="true"
                        placeholder="CC"
                        maxlength="5"
                        class="CreateAccount"
                        regExp="([+0-9])*"
                      />
                    </div>
                    <div class="Flex_Cell" width="1%"></div>
                    <div class="Flex_Cell" width="65%">
                      <AcceptInput
                        :maxlength="MobileNoCC == '+91' ? '10' : '20'"
                        style="padding-left:0 padding-right:0"
                        ref="userMobile"
                        type="textbox"
                        v-model="userMobile"
                        :isRequired="true"
                        placeholder="ENTER MOBILE NO."
                        class="CreateAccount"
                        regExp="([0-9])*"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="Flex_Cell" width="4%"></div>
              <div class="Flex_Cell" width="30%">
                <span>Email</span>
                <span style="color: red; font-weight: bold">*</span>
                <AcceptInput
                  maxlength="112"
                  ref="userEmail"
                  type="email"
                  :isRequired="true"
                  placeholder="ENTER EMAIL"
                  v-model="userEmail"
                  class="CreateAccount"
                />
              </div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell" width="30%">
                <span>Title</span>
                <span style="color: red; font-weight: bold">*</span>
                <select
                  class="CreateAccount"
                  id="ddlMemberTitle"
                  v-model="titleID"
                >
                  <option
                    v-for="m in memberTitleList"
                    :key="m.titleID"
                    v-bind:value="m.titleID"
                  >
                    {{ m.titleName }}
                  </option>
                </select>
              </div>
              <div class="Flex_Cell" width="4%"></div>
              <div class="Flex_Cell" width="30%">
                <span>First Name</span>
                <span style="color: red; font-weight: bold">*</span>
                <AcceptInput
                  maxlength="112"
                  ref="fName"
                  type="textbox"
                  :isRequired="true"
                  placeholder="ENTER FIRST NAME"
                  v-model="fName"
                  class="CreateAccount"
                  regExp="([A-Z a-z()])*"
                />
              </div>
              <div class="Flex_Cell" width="4%"></div>
              <div class="Flex_Cell" width="30%">
                <span>Middle Name</span>
                <AcceptInput
                  maxlength="112"
                  ref="mName"
                  type="textbox"
                  placeholder="ENTER MIDDLE NAME"
                  v-model="mName"
                  class="CreateAccount"
                  regExp="([A-Z a-z()])*"
                />
              </div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell" width="30%">
                <span>Last Name</span>
                <span style="color: red; font-weight: bold">*</span>
                <AcceptInput
                  maxlength="112"
                  ref="lName"
                  type="textbox"
                  :isRequired="true"
                  placeholder="ENTER LAST NAME"
                  v-model="lName"
                  class="CreateAccount"
                  regExp="([A-Z a-z()])*"
                />
              </div>
              <div class="Flex_Cell" width="4%"></div>
              <div class="Flex_Cell" width="30%">
                <span>Organization Name</span>
                <span style="color: red; font-weight: bold">*</span>
                <AcceptInput
                  maxlength="112"
                  ref="Organization"
                  type="textbox"
                  :isRequired="true"
                  placeholder="ENTER ORGANIZATION NAME"
                  v-model="org"
                  class="CreateAccount"
                  regExp="([A-Z a-z()])*"
                />
              </div>
              <div class="Flex_Cell" width="4%"></div>
              <div class="Flex_Cell" width="30%">
                <span>Designation</span>
                <span style="color: red; font-weight: bold">*</span>
                <AcceptInput
                  maxlength="112"
                  ref="Designation"
                  type="textbox"
                  :isRequired="true"
                  placeholder="ENTER DESIGNATION"
                  v-model="desig"
                  class="CreateAccount"
                  regExp="([A-Z a-z()])*"
                />
              </div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell" width="30%">
                <span>Date of Birth</span>
                <DateControl style="width: 100%" v-model="dob"></DateControl>
              </div>
              <div class="Flex_Cell" width="4%"></div>
              <div class="Flex_Cell" width="30%">
                <br />
                <span>Gender</span>
                <span style="color: red; font-weight: bold">*</span>
                <input
                  id="rblGender_0"
                  v-model="gender"
                  type="radio"
                  name="rblGender"
                  value="1"
                  checked="checked"
                  class="rblgender"
                />
                <label for="rblGender_0" class="lblClass">Male</label>
                &nbsp;
                <input
                  id="rblGender_1"
                  v-model="gender"
                  type="radio"
                  name="rblGender"
                  value="2"
                  class="rblgender"
                />
                <label for="rblGender_1" class="lblClass">Female</label>
              </div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell" width="30%">
                <span>Password</span>
                <span style="color: red; font-weight: bold">*</span>
                <AcceptInput
                  maxlength="112"
                  ref="userPassword"
                  type="password"
                  :isRequired="true"
                  placeholder="ENTER NEW PASSWORD"
                  v-model="userPassword"
                  class="CreateAccount"
                  @keyup="checkPasswordStrength($event)"
                  autocomplete="off"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                />
              </div>
              <div class="Flex_Cell" width="4%"></div>
              <div class="Flex_Cell" width="30%">
                <span>Confirm Password</span>
                <span style="color: red; font-weight: bold">*</span>
                <AcceptInput
                  maxlength="112"
                  ref="confirmPassword"
                  type="password"
                  :isRequired="true"
                  placeholder="CONFIRM PASSWORD"
                  v-model="confirmPassword"
                  @keyup="confirmPasswordMatch($event, 1)"
                  class="CreateAccount"
                  autocomplete="off"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                />
              </div>
              <div class="Flex_Cell" width="4%"></div>
              <div class="Flex_Cell" width="30%">
                <span>Captcha</span>
                <span style="color: red; font-weight: bold">*</span>
                <div class="Flex_Table">
                  <div class="Flex_Row">
                    <div class="Flex_Cell" width="50%">
                      <AcceptInput
                        maxlength="6"
                        style="padding-left:0 padding-right:0"
                        ref="captcha"
                        type="textbox"
                        v-model="captchaValue"
                        :isRequired="true"
                        placeholder="CAPTCHA"
                        class="CreateAccount"
                        regExp="([0-9])*"
                      />
                    </div>
                    <div class="Flex_Cell" width="1%"></div>
                    <div class="Flex_Cell" width="47%">
                      <img id="imgCaptcha" style="border: 1px solid #000" />
                    </div>
                    <div class="Flex_Cell" width="5%">
                      <img
                        src="../assets/images/refresh.png"
                        v-on:click="generateCaptcha(1, 110, 47)"
                        style="
                          cursor: pointer;
                          height: 25px;
                          border: 1px solid #000;
                          border-radius: 50%;
                        "
                        title="Click here to refresh captcha"
                      />
                    </div>
                    <div class="Flex_Cell"></div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <hr />
          </div>
          <div class="Flex_Table Wrap" width="100%">
            <div class="Flex_Row">
              <div class="Flex_Cell" style="text-align: center" width="100%">
                <input
                  type="button"
                  value="Register Login"
                  v-on:click="createNewUser()"
                />
                <input
                  type="button"
                  value="Cancel"
                  v-on:click="hideCreateAccount()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalPopup
        title="Verify OTP"
        ref="ModalPopup2"
        @closed="modalPopupClosed"
        @opened="modalPopupShown"
        v-model="isVerifyOTPReq"
        :okButton="$refs.btnOk"
        :cancelButton="$refs.btnOk"
      >
        <div
          id="CreateLoginBlock"
          v-if="isVerifyOTPReq"
          style="width: 100%; min-height: 100%"
        >
          <div class="Flex_Table CreateLoginContent">
            <div
              class="Flex_Row"
              v-if="isEMailOTPRequired && IsEMailActivated == 0"
            >
              <div class="Flex_Cell" style="width: 72%">
                Email <span style="color: red; font-weight: bold">*</span>
              </div>
              <div class="Flex_Cell" style="width: 4%"></div>
              <div class="Flex_Cell" style="width: 24%" v-if="isVOTPSent">
                OTP <span style="color: red; font-weight: bold">*</span>
              </div>
            </div>
            <div class="Flex_Row" v-if="isEMailOTPRequired">
              <div class="Flex_Cell" style="width: 72%">
                <AcceptInput
                  maxlength="112"
                  ref="emailID"
                  type="email"
                  :isRequired="true"
                  placeholder="PLEASE ENTER YOUR EMAIL"
                  v-model="verifyEmail"
                  class="CreateAccount"
                  :disabled="true"
                />
              </div>
              <div class="Flex_Cell" style="width: 4%"></div>
              <div class="Flex_Cell" style="width: 24%" v-if="isVOTPSent">
                <AcceptInput
                  maxlength="6"
                  style="padding-left:0 padding-right:0"
                  ref="emailOTP"
                  type="textbox"
                  v-model="emailOTP"
                  :isRequired="true"
                  class="CreateAccount"
                  placeholder="OTP"
                  regExp="([0-9])*"
                />
              </div>
            </div>
            <div
              class="Flex_Row"
              v-if="isMobileOTPRequired && IsMobileActivated == 0"
              style="margin-top: 10px"
            >
              <div class="Flex_Cell" style="width: 65%">
                Mobile <span style="color: red; font-weight: bold">*</span>
              </div>
              <div class="Flex_Cell" style="width: 5%"></div>
              <div class="Flex_Cell" style="width: 28%" v-if="isVOTPSent">
                OTP <span style="color: red; font-weight: bold">*</span>
              </div>
            </div>
            <div class="Flex_Row" v-if="isMobileOTPRequired">
              <div class="Flex_Cell" style="width: 65%">
                <AcceptInput
                  maxlength="10"
                  style="padding-left:0 padding-right:0"
                  ref="mobile"
                  type="textbox"
                  v-model="verifyMobile"
                  :isRequired="true"
                  placeholder="PLEASE ENTER YOUR MOBILE NO."
                  class="CreateAccount"
                  regExp="([0-9])*"
                />
              </div>
              <div class="Flex_Cell" style="width: 5%"></div>
              <div class="Flex_Cell" style="width: 28%" v-if="isVOTPSent">
                <AcceptInput
                  maxlength="6"
                  style="padding-left:0 padding-right:0"
                  ref="mobileOTP"
                  type="textbox"
                  v-model="mobileOTP"
                  :isRequired="true"
                  class="CreateAccount"
                  placeholder="OTP"
                  regExp="([0-9])*"
                />
              </div>
            </div>
            <div class="Flex_Row" v-if="OtpForgetPassCaptchaID != 0">
              <div class="Flex_Cell" style="width: 40%">
                <span>Captcha</span>
                <span style="color: red; font-weight: bold">*</span>
              </div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell" style="width: 35%">
                <input
                  type="text"
                  ref="captchaValueForMobEmailVerification"
                  v-model="captchaValueForMobEmailVerification"
                  style="padding: 10px 20px"
                  placeholder="CAPTCHA"
                  maxlength="6"
                />
              </div>
              <div
                class="Flex_Cell"
                style="width: 30%; padding-left: 10px; margin-left: 10px"
              >
                <img
                  id="imgCaptchaForMobEmailVerification"
                  style="border: 1px solid #000; height: 80%"
                />
              </div>
              <div
                class="Flex_Cell"
                align="left"
                style="
                  width: 30%;
                  padding-top: 6px;
                  padding-left: 0px;
                  margin-left: 10px;
                "
              >
                <img
                  src="../assets/images/refresh.png"
                  v-on:click="generateCaptcha(5, 120, 42)"
                  style="
                    cursor: pointer;
                    height: 25px;
                    border: 1px solid #000;
                    border-radius: 50%;
                  "
                  title="Click here to refresh captcha"
                />
              </div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell" align="left" style="width: 65%">
                <input
                  type="button"
                  value="Get OTP"
                  v-if="!isVOTPSent"
                  v-on:click="getOTPForVerification(2)"
                  :disabled="isDisabled"
                />
                <input
                  type="button"
                  value="RESEND"
                  v-if="!isDisabled && isVOTPSent"
                  v-on:click="getOTPForVerification(2)"
                  :disabled="isDisabled"
                />
                <span v-if="isVOTPSent && isDisabled">
                  Resend OTP after
                  {{
                    this.minutesLeft +
                    ":" +
                    (this.secondsLeft > 9
                      ? this.secondsLeft
                      : "0" + this.secondsLeft)
                  }}
                </span>
              </div>
              <div class="Flex_Cell" style="width: 5%"></div>
              <div
                class="Flex_Cell"
                v-if="isVOTPSent"
                align="right"
                style="width: 28%"
              >
                <input
                  type="button"
                  value="Verify OTP"
                  v-on:click="verifyOTP(1)"
                />
              </div>
            </div>
          </div>
        </div>
      </ModalPopup>
      <ModalPopup
        title="Forgot Password"
        ref="ModalPopup1"
        @closed="modalPopupClosed"
        @opened="modalPopupShown"
        v-model="forgotPassworddiv"
        :okButton="$refs.btnOk"
        :cancelButton="$refs.btnOk"
      >
        <div
          id="CreateLoginBlock"
          v-if="forgotPassworddiv"
          style="width: 100%; min-height: 100%"
        >
          <div class="CreateLoginContent">
            <div class="Flex_Table" v-if="!forgotVerification">
              <!-- <div class="Flex_Row" v-if="isEMailOTPRequired"> -->
              <div class="Flex_Row">
                <div class="Flex_Cell" style="width: 65%">
                  <span>Email</span>
                  <span style="color: red; font-weight: bold">*</span>
                  <AcceptInput
                    maxlength="112"
                    ref="forgotEmail"
                    type="email"
                    :isRequired="true"
                    placeholder="PLEASE ENTER YOUR EMAIL "
                    v-model="forgotEmail"
                    class="CreateAccount"
                  />
                </div>
                <div class="Flex_Cell" style="width: 5%"></div>
                <!-- v-if="isEMailOTPRequired && forgotOTPSend" -->
                <div
                  class="Flex_Cell"
                  v-if="isEMailOTPRequired && forgotOTPSend"
                  style="width: 28%"
                >
                  <span>Email OTP</span>
                  <span style="color: red; font-weight: bold">*</span>
                  <AcceptInput
                    maxlength="6"
                    ref="forgotOTP"
                    type="textbox"
                    :isRequired="true"
                    placeholder="EMAIL OTP"
                    v-model="forgotEmailOTP"
                    class="CreateAccount"
                  />
                </div>
              </div>
              <div class="Flex_Row">
                <div
                  class="Flex_Cell"
                  style="width: 65%"
                  v-if="isMobileOTPRequired"
                >
                  <span>Mobile Number</span>
                  <span style="color: red; font-weight: bold">*</span>
                  <AcceptInput
                    maxlength="10"
                    style="padding-left:0 padding-right:0"
                    ref="forgotMobile"
                    type="textbox"
                    v-model="forgotMobile"
                    :isRequired="true"
                    placeholder="PLEASE ENTER YOUR MOBILE NO."
                    class="CreateAccount"
                    regExp="([0-9])*"
                  />
                </div>
                <div class="Flex_Cell" style="width: 5%"></div>
                <div
                  class="Flex_Cell"
                  v-if="isMobileOTPRequired && forgotOTPSend"
                  style="width: 28%"
                >
                  <span>Mobile OTP</span>
                  <span style="color: red; font-weight: bold">*</span>
                  <AcceptInput
                    maxlength="6"
                    ref="forgotMobOTP"
                    type="textbox"
                    :isRequired="true"
                    placeholder="Mobile OTP"
                    v-model="forgotMobOTP"
                    class="CreateAccount"
                  />
                </div>
              </div>
              <div class="Flex_Row" v-if="OtpForgetPassCaptchaID != 0">
                <div class="Flex_Cell" style="width: 40%">
                  <span>Captcha</span>
                  <span style="color: red; font-weight: bold">*</span>
                </div>
              </div>
              <div class="Flex_Row" v-if="OtpForgetPassCaptchaID != 0">
                <div class="Flex_Cell" style="width: 35%">
                  <input
                    type="text"
                    v-model="captchaValueForForgetPass"
                    style="padding: 10px 20px"
                    placeholder="CAPTCHA"
                    maxlength="6"
                  />
                </div>
                <div
                  class="Flex_Cell"
                  style="width: 30%; padding-left: 10px; margin-left: 10px"
                >
                  <img
                    id="imgCaptchaForForgetPass"
                    style="border: 1px solid #000; height: 80%"
                  />
                </div>
                <div
                  class="Flex_Cell"
                  align="left"
                  style="
                    width: 30%;
                    padding-top: 6px;
                    padding-left: 0px;
                    margin-left: 10px;
                  "
                >
                  <img
                    src="../assets/images/refresh.png"
                    v-on:click="generateCaptcha(6, 120, 45)"
                    style="
                      cursor: pointer;
                      height: 25px;
                      border: 1px solid #000;
                      border-radius: 50%;
                    "
                    title="Click here to refresh captcha"
                  />
                </div>
              </div>
              <div class="Flex_Row">
                <div class="Flex_Cell" align="center" v-if="!forgotOTPSend">
                  <input
                    type="button"
                    value="GET OTP"
                    v-if="!isDisabled"
                    v-on:click="getOTPForgotPass()"
                    :disabled="isDisabled"
                  />
                </div>
                <div class="Flex_Cell" align="left" v-if="forgotOTPSend">
                  <input
                    type="button"
                    value="RESEND OTP"
                    v-if="!isDisabled"
                    v-on:click="getOTPForgotPass()"
                    :disabled="isDisabled"
                  />
                </div>
                <div
                  class="Flex_Cell"
                  align="left"
                  valign="middle"
                  v-if="forgotOTPSend && isDisabled"
                >
                  <span>
                    Resend OTP after
                    {{
                      this.minutesLeft +
                      ":" +
                      (this.secondsLeft > 9
                        ? this.secondsLeft
                        : "0" + this.secondsLeft)
                    }}
                  </span>
                </div>
                <div class="Flex_Cell" align="right" v-if="forgotOTPSend">
                  <input
                    type="button"
                    value="Verify OTP"
                    v-on:click="verifyOTP(2)"
                  />
                </div>
              </div>
            </div>
            <div
              class="Flex_Table"
              style="padding: 5px"
              v-if="eMailOTPRef != ''"
            >
              <div class="Flex_Row" v-if="eMailOTPRef != ''">
                <div class="Flex_Cell" v-if="false">
                  EMAIL:
                  <span
                    >OTP is sent in your email with <b>{{ eMailOTPRef }}</b> ref
                    id
                  </span>
                </div>
              </div>
              <div class="Flex_Row" v-if="mobileOTPRef != ''">
                <div class="Flex_Cell">
                  MOBILE:
                  <span
                    >OTP is sent in your mobile with
                    <b>{{ mobileOTPRef }}</b> ref id
                  </span>
                </div>
              </div>
            </div>
            <div class="Flex_Table" v-if="forgotVerification">
              <div class="Flex_Row">
                <div class="Flex_Cell">
                  <span>New Password</span>
                  <span style="color: red; font-weight: bold">*</span>
                </div>
              </div>
              <div class="Flex_Row">
                <div class="Flex_Cell">
                  <input
                    maxlength="112"
                    type="password"
                    :isRequired="true"
                    placeholder="PLEASE ENTER YOUR NEW PASSWORD"
                    v-model="newPassword"
                    class="CreateAccount"
                    readonly
                    onfocus="this.removeAttribute('readonly');"
                    @keyup="checkPasswordStrength($event)"
                  />
                </div>
              </div>
              <div class="Flex_Row">
                <div class="Flex_Cell">
                  <span>Confirm Password</span>
                  <span style="color: red; font-weight: bold">*</span>
                </div>
              </div>
              <div class="Flex_Row">
                <div class="Flex_Cell">
                  <input
                    maxlength="112"
                    type="password"
                    :isRequired="true"
                    @keyup="confirmPasswordMatch($event, 2)"
                    placeholder="PLEASE CONFIRM YOUR NEW PASSWORD"
                    readonly
                    onfocus="this.removeAttribute('readonly');"
                    v-model="newConfirmPassword"
                    class="CreateAccount"
                  />
                </div>
              </div>
              <div class="Flex_Row">
                <div class="Flex_Cell">
                  <span>Captcha</span>
                  <span style="color: red; font-weight: bold">*</span>
                </div>
                <div class="Flex_Cell"></div>
              </div>
              <div class="Flex_Row">
                <div class="Flex_Cell" style="width: 40%">
                  <input
                    type="text"
                    v-model="captchaValueforPwd"
                    placeholder="CAPTCHA"
                    style="padding: 10px 20px"
                    maxlength="6"
                  />
                </div>
                <div class="Flex_Cell" style="width: 2%"></div>
                <div class="Flex_Cell">
                  <img
                    id="imgCaptchaForPwd"
                    style="width: 51%; border: 1px solid #000"
                  />
                  <img
                    src="../assets/images/refresh.png"
                    v-on:click="generateCaptcha(2, 120, 45)"
                    style="
                      cursor: pointer;
                      height: 25px;
                      border: 1px solid #000;
                      border-radius: 50%;
                    "
                    title="Click here to refresh captcha"
                  />
                </div>
              </div>
              <br />
              <hr />
              <div class="Flex_Row">
                <div class="Flex_Cell" style="text-align: center">
                  <input
                    type="button"
                    v-model="resetPWD"
                    v-on:click="setNewPassword()"
                  />
                  <input
                    type="button"
                    value="Cancel"
                    v-on:click="hideCreateAccount()"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </ModalPopup>
      <ModalPopup
        title="Change Password"
        ref="ModalPopup1"
        @closed="modalPopupClosed"
        @opened="modalPopupShown"
        v-model="changePassworddiv"
        :okButton="$refs.btnOk"
        :cancelButton="$refs.btnOk"
      >
        <div
          id="CreateLoginBlock"
          v-if="changePassworddiv"
          style="width: 100%; min-height: 100%"
        >
          <div class="CreateLoginContent">
            <div class="Flex_Table">
              <!-- <div class="Flex_Row" v-if="isEMailOTPRequired"> -->
              <div class="Flex_Row">
                <div class="Flex_Cell">
                  <span>Email/Mobile</span>
                  <span style="color: red; font-weight: bold">*</span>
                  <input
                    maxlength="112"
                    ref="changePassEmailMob"
                    type="email"
                    :isRequired="true"
                    placeholder="PLEASE ENTER YOUR EMAIL/MOBILE"
                    v-model="changePassEmailMob"
                    class="CreateAccount"
                  />
                </div>
              </div>
              <div class="Flex_Row">
                <div class="Flex_Cell">
                  <span>Old Password</span>
                  <span style="color: red; font-weight: bold">*</span>
                  <input
                    maxlength="112"
                    type="password"
                    :isRequired="true"
                    placeholder="PLEASE ENTER OLD PASSWORD"
                    v-model="oldPassword"
                    class="CreateAccount"
                    readonly
                    onfocus="this.removeAttribute('readonly');"
                  />
                </div>
              </div>
              <div class="Flex_Row">
                <div class="Flex_Cell">
                  <span>New Password</span>
                  <span style="color: red; font-weight: bold">*</span>
                  <input
                    maxlength="112"
                    type="password"
                    :isRequired="true"
                    placeholder="PLEASE ENTER NEW PASSWORD"
                    v-model="newPassword"
                    class="CreateAccount"
                    readonly
                    onfocus="this.removeAttribute('readonly');"
                    @keyup="checkPasswordStrength($event)"
                  />
                </div>
              </div>
              <div class="Flex_Row">
                <div class="Flex_Cell">
                  <span>Confirm Password</span>
                  <span style="color: red; font-weight: bold">*</span>
                  <input
                    maxlength="112"
                    type="password"
                    :isRequired="true"
                    @keyup="confirmPasswordMatch($event, 2)"
                    placeholder="PLEASE CONFIRM NEW PASSWORD"
                    readonly
                    onfocus="this.removeAttribute('readonly');"
                    v-model="newConfirmPassword"
                    class="CreateAccount"
                  />
                </div>
              </div>
              <div class="Flex_Row" v-if="ChangePassCaptchaID != 0">
                <div class="Flex_Cell">
                  <span>Captcha</span>
                  <span style="color: red; font-weight: bold">*</span>
                </div>
              </div>
              <div class="Flex_Row" v-if="ChangePassCaptchaID != 0">
                <div class="Flex_Cell" style="width: 40%">
                  <input
                    type="text"
                    v-model="captchaValueForChangePass"
                    style="padding: 10px 20px"
                    placeholder="CAPTCHA"
                    maxlength="6"
                  />
                </div>
                <div
                  class="Flex_Cell"
                  style="width: 35%; padding-left: 10px; margin-left: 10px"
                >
                  <img
                    id="imgCaptchaForChangePass"
                    style="border: 1px solid #000; height: 80%"
                  />
                </div>
                <div
                  class="Flex_Cell"
                  align="left"
                  style="padding-top: 6px; padding-left: 0px; margin-left: 10px"
                >
                  <img
                    src="../assets/images/refresh.png"
                    v-on:click="generateCaptcha(8, 120, 45)"
                    style="
                      cursor: pointer;
                      height: 25px;
                      border: 1px solid #000;
                      border-radius: 50%;
                    "
                    title="Click here to refresh captcha"
                  />
                </div>
              </div>
              <div class="Flex_Row">
                <div class="Flex_Cell" align="center">
                  <input
                    type="button"
                    value="Change Password"
                    v-if="!isDisabled"
                    v-on:click="changePassword()"
                    :disabled="isDisabled"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </ModalPopup>
    </div>
    <div
      id="divBrowserNotSupported"
      v-if="!isBrowserCompatibility"
      class="browserDiv"
    >
      Your Browser Version Not Supported! Please Update.
      <br />
      Supported Browsers are :
      <div>
        <img
          src="../assets/images/ie.png"
          style="width: 24px; vertical-align: middle"
        />
        Internet Explorer 11+/edge,
      </div>
      <div>
        <img
          src="../assets/images/chrome.png"
          style="width: 24px; vertical-align: middle"
        />
        Google Chrome 60+,
      </div>
      <div>
        <img
          src="../assets/images/firefox.png"
          style="width: 24px; vertical-align: middle"
        />
        Mozilla FireFox 60+,
      </div>
      <div>
        <img
          src="../assets/images/opera.png"
          style="width: 24px; vertical-align: middle"
        />
        Opera 60+.
      </div>
    </div>
    <div id="divBrowserInfo"></div>
    <div class="Flex_Table tblEntryForm companyLogo" style="display: none">
      <div class="Flex_Row">
        <div class="Flex_Cell" align="center" style="width: 100%">
          &copy; Border Roads Organisation {{ curYear }} / All rights reserved.
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span style="cursor: pointer" v-on:click="redirectToWebSite()"
            >Developed by Ekklavya</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
@import url("../assets/css/Login_v1.0.css");
@import url("../assets/css/Theme/main_v1.0.css");
@import url("../assets/css/Theme/Desktop_v1.0.css");
@import url("../assets/css/Theme/Mobile_Landscape_v1.0.css");
@import url("../assets/css/Theme/Mobile_Portrait_v1.0.css");
.companyLogo {
  position: sticky;
  color: white;
  font-weight: bold;
  text-shadow: 1px 1px 2px #000, 0 0 25px #151515, 0 0 5px #131313;
  padding-bottom: 10px;
  top: 100%;
}
#CreateLoginBlock {
  min-height: 300px;
  background-color: rgba(255, 255, 255, 0.99) !important;
  border-radius: 10px;
  width: 830px;
  height: 100%;
  padding: 10px;
}
.CreateLoginBlockHeader {
  width: 100%;
  color: black;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  font-size: 18px;
  border-radius: 3px;
  text-align: center;
}
.CreateLoginContent {
  width: 100%;
  height: 100%;
  color: black;
  border: 1px solid #000;
  padding: 2px 9px 6px 9px;
}
.CreateAccount {
  width: 100%;
  padding: 10px 10px;
  margin: 4px 0;
  box-sizing: border-box;
  border-radius: 4px;
  background-color: aliceblue;
}
.rblGender input[type="radio"] {
  position: fixed;
  width: 0;
  cursor: pointer;
  opacity: 0.55;
}
.lblClass {
  display: inline;
  padding: 3px 3px 3px 3px;
  border: solid 1px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 15px;
}
.lblClass:hover {
  background-color: rgba(1, 166, 248, 0.726);
}
.makeUpperCase {
  text-transform: uppercase;
}
@media screen and (max-width: 1023px) {
  #CreateLoginBlock {
    min-height: 300px;
    background-color: rgba(255, 255, 255, 0.95) !important;
    border-radius: 10px;
    width: 99vw;
  }
}
.Instruction {
  border: solid 1px black;
  padding: 8px;
  margin-bottom: 10px;
  margin-top: 10px;
}
.AnchorOTP {
  font-weight: 700;
  color: blue;
  text-decoration: underline;
}
.CreateLoginContent .Flex_Cell,
.CreateLoginContent .Flex_Cell_Inline {
  padding: 0px 0px !important;
}
#dvVerifyOTP {
  min-height: 250px;
  background-color: rgba(255, 255, 255, 0.99) !important;
  border-radius: 10px;
  width: 550px;
  height: 100%;
  padding: 10px;
}

@media screen and (max-width: 800px) {
  .imgHeight {
    height: 59%;
  }
}
@media screen and (max-width: 480px) {
  .imgHeight {
    height: 80px;
  }
}
</style>
<script>
import vue from "vue";
import Router from "vue-router";
import config from "@/router/globalConfig";
import AcceptInput from "./ekkControls/AcceptInput";
import DateControl from "./ekkControls/DateControl";
import ModalPopup from "./ekkControls/ModalPopup";
import LoginJS from "./serviceJS/loginjs.js";
import MasterJS from "./serviceJS/masterJS.js";

export default {
  name: "Login",
  components: {
    AcceptInput: AcceptInput,
    DateControl: DateControl,
    ModalPopup: ModalPopup,
  },
  data() {
    return {
      curYear: new Date().convertToString("yyyy"),
      loginName: "",
      loginPassword: "",
      loginOTP: "",
      isAdvertisementValid: true,
      createNewAccountdiv: false,
      forgotPassworddiv: false,
      forgotPassworddivorddiv: false,
      hideBg: false,
      titleID: 1,
      fName: "",
      mName: "",
      lName: "",
      dob: new Date("01 Jan 1900"),
      userMobile: "",
      userEmail: "",
      userPassword: "",
      confirmPassword: "",
      gender: "M",
      forgotEmail: "",
      forgotMobile: "",
      newPassword: "",
      newConfirmPassword: "",
      isPasswordStrenth: false,
      captchakey: "",
      captchaValue: "",
      forgotVerification: false,
      verifyCredential: "Generate OTP",
      isDisabled: false,
      resetPWD: "Reset Password",
      captchakeyforPwd: "",
      captchaValueforPwd: "",
      captchakeyforGetOTP: "",
      captchaValueforGetOTP: "",
      OtpCaptchaID: 0,
      OtpVerifyCaptchaID: 0,
      OtpForgetPassCaptchaID: 0,
      captchakeyforResendOTP: "",
      captchaValueforResendOTP: "",
      minutesLeft: 1,
      secondsLeft: 59,
      forgotOTPSend: false,
      forgotEmailOTP: "",
      forgotMobOTP: "",
      isEMailOTPRequired: false,
      isMobileOTPRequired: false,
      IsEMailActivated: false,
      IsMobileActivated: false,
      verifyEmail: "",
      verifyMobile: "",
      emailOTP: "",
      mobileOTP: "",
      isVerifyOTPReq: false,
      captchaValueForForgetPass: "",
      captchaKeyForForgetPass: "",
      captchaValueForMobEmailVerification: "",
      captchaKeyForMobEmailVerification: "",
      captchaKeyForLogin: "",
      captchaValueforLogin: "",
      btnName: "Get OTP",
      eMailOTPRef: "",
      mobileOTPRef: "",
      isOTPTimeLeft: false,
      dOBCheckList: [],
      isBrowserCompatibility: true,
      userTypeList: [],
      userTypeID: -1,
      memberTitleList: [],
      genderList: [],
      gender: "",
      org: "",
      desig: "",
      loginTypeID: 1,
      loginWithPass: false,
      loginWithOTP: true,
      MobileNoCC: "+91",
      isVOTPSent: false,
      ChangePassCaptchaID: 0,
      changePassEmailMob: "",
      captchaValueForChangePass: "",
      captchaKeyForChangePass: "",
      changePassworddiv: false,
      oldPassword: "",
    };
  },
  methods: {
    checkBrowserVersion(target, msgTarget) {
      //let nVer = navigator.appVersion;
      let nAgt = navigator.userAgent;
      let browserName = navigator.appName;
      let fullVersion = "" + parseFloat(navigator.appVersion);
      let majorVersion = parseInt(navigator.appVersion, 10);
      let nameOffset, verOffset, ix;

      // In Opera 15+, the true version is after "OPR/"
      if ((verOffset = nAgt.indexOf("OPR/")) != -1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset + 4);
      }
      // In older Opera, the true version is after "Opera" or after "Version"
      else if ((verOffset = nAgt.indexOf("Opera")) != -1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf("Version")) != -1) {
          fullVersion = nAgt.substring(verOffset + 8);
        }
      }
      // In MSIE, the true version is after "MSIE" in userAgent
      else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
        browserName = "MSIE";
        fullVersion = nAgt.substring(verOffset + 5);
      }
      // In Chrome, the true version is after "Chrome"
      else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset + 7);
      }
      // In Safari, the true version is after "Safari" or after "Version"
      else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf("Version")) != -1) {
          fullVersion = nAgt.substring(verOffset + 8);
        }
      }
      // In Firefox, the true version is after "Firefox"
      else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
        browserName = "Firefox";
        fullVersion = nAgt.substring(verOffset + 8);
      }
      // In most other browsers, "name/version" is at the end of userAgent
      else if (
        (nameOffset = nAgt.lastIndexOf(" ") + 1) <
        (verOffset = nAgt.lastIndexOf("/"))
      ) {
        browserName = nAgt.substring(nameOffset, verOffset);
        fullVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() == browserName.toUpperCase()) {
          browserName = navigator.appName;
        }
      }
      // trim the fullVersion string at semicolon/space if present
      if ((ix = fullVersion.indexOf(";")) != -1)
        fullVersion = fullVersion.substring(0, ix);
      if ((ix = fullVersion.indexOf(" ")) != -1)
        fullVersion = fullVersion.substring(0, ix);

      majorVersion = parseInt("" + fullVersion, 10);
      if (isNaN(majorVersion)) {
        fullVersion = "" + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
      }
      let html = "";
      html += "Browser name  = " + browserName + "<br>";
      html += "Full version  = " + fullVersion + "<br>";
      html += "Major version = " + majorVersion + "<br>";
      //html += 'navigator.appName = ' + navigator.appName + '<br>';
      //html += 'navigator.userAgent = ' + navigator.userAgent + '<br>';
      if (target) {
        //target.innerHTML = html;
        if (browserName == "Opera" && majorVersion < 60) {
          this.isBrowserCompatibility = false;
          //$(msgTarget).hide();
        } else if (browserName == "MSIE" && majorVersion < 11) {
          this.isBrowserCompatibility = false;
          //$(msgTarget).hide();
        } else if (browserName == "Chrome" && majorVersion < 60) {
          this.isBrowserCompatibility = false;
          //$(msgTarget).hide();
        } else if (browserName == "Safari" && majorVersion < 14) {
          this.isBrowserCompatibility = false;
          //$(msgTarget).hide();
        } else if (browserName == "Firefox" && majorVersion < 60) {
          this.isBrowserCompatibility = false;
          //$(msgTarget).hide();
        } else if (browserName == "Netscape" && majorVersion < 5) {
          this.isBrowserCompatibility = false;
          //$(msgTarget).hide();
        }
      }
    },
    modalPopupClosed(e) {
      this.hideCreateAccount();
      this.clearPage();
    },
    modalPopupShown(e) {
      //console.log("Modal Popup Shown");
    },
    hideCreateAccount() {
      this.changePassEmailMob = "";
      this.oldPassword = "";
      this.newPassword = "";
      this.newConfirmPassword = "";
      this.captchaValueForChangePass = "";
      this.changePassworddiv = false;
      this.createNewAccountdiv = false;
      this.forgotPassworddiv = false;
      this.hideBg = false;
      document.getElementById("divLogin").style.backgroundColor = "";
      this.userMobile = "";
      this.userEmail = "";
      this.userPassword = "";
      this.confirmPassword = "";
      this.gender = "M";
      this.forgotLogin = "";
      this.forgotMobile = "";
      this.forgotMobOTP = "";
      this.forgotEmail = "";
      this.forgotEmailOTP = "";
      this.newPassword = "";
      this.newConfirmPassword = "";
      this.isPasswordStrenth = false;
      this.fName = "";
      this.mName = "";
      this.lName = "";
      this.dob = new Date("01 Jan 1900");
      this.captchaValue = "";
      this.forgotVerification = false;
      this.captchakeyforPwd = "";
      this.captchaValueforPwd = "";
      this.minutesLeft = 1;
      this.secondsLeft = 59;
      this.btnName = "Generate OTP";
      this.isDisabled = false;
      this.timeLeft = true;
      this.forgotOTPSend = false;
      this.forgotOTP = "";
      this.isVerifyOTPReq = false;
      this.emailOTP = "";
      this.mobileOTP = "";
      this.eMailOTPRef = "";
      this.mobileOTPRef = "";
      this.isOTPTimeLeft = false;
      this.loginName = "";
      this.loginPassword = "";
      this.loginOTP = "";
      this.verifyCredential = "Generate OTP";
      this.clearPage();
    },
    clearPage(type) {
      if (type != 1) {
        this.GetSetupData();
      }
      this.loginName = "";
      this.loginPassword = "";
      this.loginOTP = "";
      this.OtpCaptchaID = 0;
      this.captchaValueforGetOTP = "";
      this.captchakeyforGetOTP = "";
      this.captchaValueForMobEmailVerification = "";
      this.captchaKeyForMobEmailVerification = "";
      this.captchaKeyForLogin = "";
      this.captchaValueforLogin = "";
      this.captchaValueForForgetPass = "";
      this.captchaKeyForForgetPass = "";
      this.captchaValueforResendOTP = "";
      this.captchakeyforResendOTP = "";
    },
    changeLoginType(type, loginWithOTP, loginWithPass) {
      vue.nextTick(() => {
        this.clearPage(1);
      });
      if (type == 1) {
        this.generateCaptcha(7, 210, 40);
        this.loginTypeID = 3;
      } else {
        this.generateCaptcha(3, 100, 17);
        this.loginTypeID = 1;
      }
    },
    getUserTypeList() {
      const _data_ = { type: 1 };
      LoginJS.getUserType(_data_).then(
        (response) => {
          this.userTypeList = response.data;
          this.userTypeID = response.data[0].loginTypeID;
        },
        (error) => {}
      );
    },
    getMemberTitle() {
      // const _data_ = { rankID: -1, isActive: 1, type: 1 };
      LoginJS.GetTitle().then(
        (response) => {
          this.memberTitleList = response.data;
          this.rankID = response.data[0].titleID;
          // console.log(response);
        },
        (error) => {}
      );
    },
    generateCaptcha(type, w, h) {
      this.captchaValue = "";
      const _data_ = { width: w, height: h };
      LoginJS.GenerateCaptcha(_data_).then(
        (response) => {
          window.sessionStorage.setItem(
            "antiforgery_token",
            response.data.result2
          );
          config.AF_Token = window.sessionStorage.getItem("antiforgery_token");
          if (type == 1) {
            $("#imgCaptcha").attr("src", response.data.result1);
            this.captchakey = response.data.result;
          } else if (type == 2) {
            $("#imgCaptchaForPwd").attr("src", response.data.result1);
            this.captchakeyforPwd = response.data.result;
          } else if (type == 3) {
            $("#imgCaptchaForGetOTP").attr("src", response.data.result1);
            this.captchakeyforGetOTP = response.data.result;
          } else if (type == 4) {
            $("#imgCaptchaForResendOTP").attr("src", response.data.result1);
            this.captchakeyforResendOTP = response.data.result;
          } else if (type == 5) {
            $("#imgCaptchaForMobEmailVerification").attr(
              "src",
              response.data.result1
            );
            this.captchaKeyForMobEmailVerification = response.data.result;
          } else if (type == 6) {
            $("#imgCaptchaForForgetPass").attr("src", response.data.result1);
            this.captchaKeyForForgetPass = response.data.result;
          } else if (type == 7) {
            $("#imgCaptchaForLogin").attr("src", response.data.result1);
            this.captchaKeyForLogin = response.data.result;
          } else if (type == 8) {
            $("#imgCaptchaForChangePass").attr("src", response.data.result1);
            this.captchaKeyForChangePass = response.data.result;
          }
        },
        (error) => {
          if (error.response.data.message != undefined) {
            alert(
              error.response.data.message +
                "\n" +
                error.response.data.exceptionMessage
            );
          } else {
            alert("Error: " + error.response.data);
          }
        },
        (failure) => {
          alert("Failure: " + failure.response);
        }
      );
    },
    GetSetupData() {
      MasterJS.GetSetup().then(
        (response) => {
          // console.log(response.data);
          this.isMobileOTPRequired = response.data[0].isMobileOTPRequiredForPO;
          this.isEMailOTPRequired = response.data[0].isEMailOTPRequiredForPO;
          var loginScreenFlag = response.data[0].loginScreenFlag;
          if (loginScreenFlag == 0) {
            this.loginTypeID = 1;
            this.generateCaptcha(3, 100, 17);
            this.loginWithOTP = true;
            this.loginWithPass = true;
          } else if (loginScreenFlag == 1) {
            this.loginTypeID = 3;
            this.generateCaptcha(7, 210, 40);
            this.loginWithOTP = false;
            this.loginWithPass = true;
          } else if (loginScreenFlag == 2) {
            this.loginTypeID = 3;
            this.generateCaptcha(7, 210, 40);
            this.loginWithOTP = true;
            this.loginWithPass = true;
          } else if (loginScreenFlag == 3) {
            this.loginTypeID = 1;
            this.generateCaptcha(3, 100, 17);
            this.loginWithOTP = true;
            this.loginWithPass = false;
          }
        },
        (error) => {}
      );
    },
    checkPasswordStrength(element) {
      this.isPasswordStrenth = false;
      var obj = element.currentTarget;
      var pass = obj.value;
      var lblPasswordStreingth = document.getElementById(
        "lblPasswordStreingth"
      );

      if (lblPasswordStreingth == null) {
        lblPasswordStreingth = document.createElement("div");
        lblPasswordStreingth.id = "lblPasswordStreingth";
        lblPasswordStreingth.style.backgroundColor = "white";
        lblPasswordStreingth.style.fontWeight = "bold";
        lblPasswordStreingth.style.padding = "5px";
        lblPasswordStreingth.style.position = "sticky";
        lblPasswordStreingth.style.left = "350px";
        lblPasswordStreingth.style.whiteSpace = "wrap";
        obj.parentNode.style.position = "relative";
        $(obj).after(lblPasswordStreingth);
      }
      lblPasswordStreingth.style.color = "Red";
      lblPasswordStreingth.style.border = "solid 1px red";
      var msg;
      if (pass.length < 8 && pass.length > 0) {
        msg =
          "Password Length Must Be 8 Characters Long.<br>Password Must Have : 1 Digit, 1 Lower Character,<br>1 Upper Character and 1 Special Character.";
        lblPasswordStreingth.innerHTML = msg;
      } else if (pass.length == 0) {
        lblPasswordStreingth.innerHTML = "";
        lblPasswordStreingth.style.border = "";
        lblPasswordStreingth.style.color = "";
        this.isPasswordStrenth = false;
      } else {
        var variations = {
          digits: /\d/.test(pass),
          lower: /[a-z]/.test(pass),
          upper: /[A-Z]/.test(pass),
          nonWords: /\W/.test(pass),
        };
        msg = "Password Must Have : ";
        if (variations.digits == false) {
          msg += "1 Digit,";
        }
        if (variations.lower == false) {
          msg += "1 Lower Character,";
        }
        if (variations.upper == false) {
          msg += "1 Upper Character,";
        }
        if (variations.nonWords == false) {
          msg += "1 Special Character,";
        }
        lblPasswordStreingth.innerHTML = msg;
        if (
          variations.digits &&
          variations.lower &&
          variations.upper &&
          variations.nonWords
        ) {
          lblPasswordStreingth.innerHTML = "You Have Entered Strong Password";
          lblPasswordStreingth.style.border = "solid 1px green";
          lblPasswordStreingth.style.color = "green";
          this.isPasswordStrenth = true;
        }
      }
    },
    confirmPasswordMatch(element, type) {
      var obj = element.currentTarget;
      var newPass;
      if (type == 1) {
        newPass = this.userPassword;
      } else if (type == 2) {
        newPass = this.newPassword;
      }
      var confPass = obj.value;
      var lblConfirmPassword = document.getElementById("lblConfirmPassword");
      if (lblConfirmPassword == null) {
        lblConfirmPassword = document.createElement("div");
        lblConfirmPassword.id = "lblConfirmPassword";
        lblConfirmPassword.style.backgroundColor = "white";
        lblConfirmPassword.style.fontWeight = "bold";
        lblConfirmPassword.style.padding = "5px";
        lblConfirmPassword.style.position = "sticky";
        lblConfirmPassword.style.left = "350px";
        lblConfirmPassword.style.whiteSpace = "wrap";
        obj.parentNode.style.position = "relative";
        $(obj).after(lblConfirmPassword);
      }
      var msg;
      if (confPass.length > 0) {
        if (confPass != newPass) {
          msg = "Confirm Password should be same as New Password";
          lblConfirmPassword.style.color = "Red";
          lblConfirmPassword.style.border = "solid 1px red";
          lblConfirmPassword.innerHTML = msg;
        } else if (confPass == newPass) {
          lblConfirmPassword.innerHTML = "Password matched";
          lblConfirmPassword.style.border = "solid 1px green";
          lblConfirmPassword.style.color = "green";
        }
      } else if (confPass.length == 0) {
        lblConfirmPassword.innerHTML = "";
        lblConfirmPassword.style.border = "";
        lblConfirmPassword.style.color = "";
      } else {
        lblConfirmPassword.innerHTML = "";
        lblConfirmPassword.style.border = "";
        lblConfirmPassword.style.color = "";
      }
    },
    signUp() {
      this.hideCreateAccount();
      this.createNewAccountdiv = true;
      this.hideBg = true;
      document.getElementById("divLogin").style.backgroundColor =
        "rgba(97 108 113 / 42%)";
      this.generateCaptcha(1, 110, 47);
      this.getUserTypeList();
      //this.checkDOB();
      this.getMemberTitle();
      // this.getGenderTitle();
    },
    downloadSample() {
      MasterJS.GetHelpFile().then(
        (response) => {
          if (response.data.isSuccess) {
            var fileURL = response.data.result;
            let link = document.createElement("a");
            link.id = "mylink";
            link.href = fileURL;
            link.setAttribute(
              "download",
              "NIBM_EKKLAVYA'S USER MANUAL FOR ONLINE APPLICATION FORM FOR PROGRAMME OFFICE.pdf"
            );
            link.click();
          }
        },
        (error) => {},
        (failure) => {}
      );
    },
    authenticateUser(loginType) {
      if (this.loginName == null || this.loginName.length == 0) {
        alert("PLEASE ENTER EMAIL/MOBILE");
        return false;
      }
      if (loginType == 2) {
        if (this.loginOTP == null || this.loginOTP.length == 0) {
          alert("PLEASE ENTER OTP");
          return false;
        }
      } else if (loginType == 3) {
        if (this.loginPassword == null || this.loginPassword.length == 0) {
          alert("PLEASE ENTER PASSWORD");
          return false;
        }
        if (this.captchaValueforLogin == "") {
          alert("PLEASE ENTER CAPTCHA");
          return false;
        }
      }
      var isMobile = false;
      if (this.CheckEmailOrMob(this.loginName) == "E") {
        isMobile = false;
      } else if (this.CheckEmailOrMob(this.loginName) == "M") {
        isMobile = true;
      }
      var param = "";
      if (loginType == 2) {
        param =
          "username=" +
          encodeURIComponent(this.loginName) +
          "&password=" +
          encodeURIComponent(this.loginOTP) +
          "&imageID=-1&phraseID=-1&type=" +
          loginType +
          "&grant_type=password&CaptchaValue=&CaptchaKey=&isMobile=" +
          isMobile;
      } else if (loginType == 3) {
        param =
          "username=" +
          encodeURIComponent(this.loginName) +
          "&password=" +
          encodeURIComponent(this.loginPassword) +
          "&imageID=-1&phraseID=-1&type=" +
          loginType +
          "&grant_type=password&CaptchaValue=" +
          this.captchaValueforLogin +
          "&CaptchaKey=" +
          this.captchaKeyForLogin +
          "&isMobile=" +
          isMobile;
      }
      param += "&Token=" + config.AF_Token;
      const params = param;
      LoginJS.GetUserAuthentication(params).then(
        (result) => {
          const tokenData = result.data;
          // console.log(tokenData);
          window.sessionStorage.setItem("token", tokenData.access_token);
          window.sessionStorage.setItem("token_type", tokenData.token_type);
          window.sessionStorage.setItem(
            "refresh_token",
            tokenData.refresh_token
          );
          window.sessionStorage.setItem(
            "antiforgery_token",
            tokenData.antiforgery_token
          );
          config.LOG_Token = "bearer ".concat(
            window.sessionStorage.getItem("token")
          );
          config.AF_Token = window.sessionStorage.getItem("antiforgery_token");
          this.isUserActivated();
          //this.$router.push({ name: "Home" });
        },
        (error) => {
          //console.log(error);
          vue.nextTick(() => {
            document.getElementById("txtLogin").focus();
            if (loginType == 2) {
              this.loginOTP = "";
            } else if (loginType == 3) {
              this.loginName = "";
              this.loginPassword = "";
              this.captchaValueforLogin = "";
              this.generateCaptcha(7, 80, 16);
            }
          });
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            if (error.response.status == "401") {
              if (error.response.data.error == "invalid_grant") {
                alert(error.response.data.error_description);
              } else if (error.response.data.error == "invalid_license") {
                this.$router.push({ name: "License" });
              } else {
                alert("Invalid username or password");
              }
            } else {
              alert("Error: " + error.response.statusText);
            }
          }
          window.sessionStorage.removeItem("token");
          window.sessionStorage.removeItem("token_type");
          window.sessionStorage.removeItem("refresh_token");
        },
        (failure) => {
          vue.nextTick(() => {
            document.getElementById("txtLogin").focus();
            this.loginName = "";
            this.loginPassword = "";
            this.loginOTP = "";
          });
          alert("Failure: " + failure);
        }
      );
    },
    isUserActivated() {
      LoginJS.GetUserActivation().then(
        (response) => {
          this.eMailOTPRef = "";
          this.mobileOTPRef = "";
          this.isOTPTimeLeft = false;
          this.UserID = response.data[0].userID;
          this.verifyMobile = response.data[0].userMobile;
          this.verifyEmail = response.data[0].userEmail;
          this.IsEMailActivated = response.data[0].isEMailActivated;
          this.IsMobileActivated = response.data[0].isMobileActivated;
          {
            if (
              response.data[0].userEmail != "" ||
              response.data[0].userMobile != ""
            ) {
              if (this.isEMailOTPRequired && this.IsEMailActivated == 0) {
                this.isVerifyOTPReq = true;
                this.generateCaptcha(5, 120, 42);
              } else if (
                this.isMobileOTPRequired &&
                this.IsMobileActivated == 0
              ) {
                this.isVerifyOTPReq = true;
                this.generateCaptcha(5, 120, 42);
              } else {
                this.$router.push({ name: "Home" });
              }
            }
          }
        },
        (error) => {
          if (error.response.data.message != undefined) {
            alert(
              error.response.data.message +
                "\n" +
                error.response.data.exceptionMessage
            );
          } else {
            alert("Error: " + error.response.data);
          }
        },
        (failure) => {
          alert("Failure: " + failure.response);
        }
      );
    },
    validateInput(type) {
      if (type == 1) {
        if (this.userMobile == null || this.userMobile == "") {
          alert("Please enter your mobile number");
          this.$refs.userMobile.focus();
          return false;
        }
        if (this.userMobile.startsWith("0")) {
          alert("Mobile number cannot start with 0");
          this.$refs.userMobile.focus();
          return false;
        }
        if (this.MobileNoCC == "+91") {
          if (this.userMobile.length != "10") {
            alert("Mobile number must be 10 digits");
            this.$refs.userMobile.focus();
            return false;
          }
        } else {
          if (this.userMobile.length > 20) {
            alert("Mobile number should be less then 20 digits.");
            this.$refs.userMobile.focus();
            return false;
          }
        }
        if (!this.validEmailOrMob(this.userMobile, "M")) {
          alert("Please enter correct mobile number");
          this.$refs.userMobile.focus();
          return false;
        }
        if (this.userEmail == null || this.userEmail == "") {
          alert("Please enter your valid email");
          this.$refs.userEmail.focus();
          return false;
        }
        if (!this.$refs.userEmail.isValid) {
          alert("Email format is not valid");
          this.$refs.userEmail.focus();
          return false;
        }
        if (!this.validEmailOrMob(this.userEmail, "E")) {
          alert("Please enter correct email");
          this.$refs.userEmail.focus();
          return false;
        }

        if (this.fName == null || this.fName == "") {
          alert("Please enter your first name");
          this.$refs.fName.focus();
          return false;
        }
        if (this.lName == null || this.lName == "") {
          alert("Please enter your last name");
          this.$refs.lName.focus();
          return false;
        }
        if (this.org == null || this.org == "") {
          alert("Please enter Organization");
          this.$refs.Organization.focus();
          return false;
        }
        if (this.desig == null || this.desig == "") {
          alert("Please enter Designation");
          this.$refs.Designation.focus();
          return false;
        }
        // if (
        //   this.dob == null ||
        //   this.dob == "" ||
        //   this.dob.convertToString("dd MMM yyyy") ==
        //     new Date("01 Jan 1900").convertToString("dd MMM yyyy")
        // ) {
        //   alert("Please enter your date of birth");
        //   this.$refs.dob.focus();
        //   return false;
        // }
        if (this.dob > new Date()) {
          alert("Please enter your valid date of birth");
          this.$refs.dob.focus();
          return false;
        }
        // if (
        //   this.dob < this.dOBCheckList.minDate.toDateTime() ||
        //   this.dob > this.dOBCheckList.maxDate.toDateTime()
        // ) {
        //   alert("Date of birth is not greater or less than of min or max date");
        //   return false;
        // }
        if (this.userPassword == null || this.userPassword == "") {
          alert("Please enter your password");
          this.$refs.userPassword.focus();
          return false;
        }
        if (this.confirmPassword == null || this.confirmPassword == "") {
          alert("Please confirm your password");
          this.$refs.confirmPassword.focus();
          return false;
        }
        if (this.userPassword != this.confirmPassword) {
          alert("Password and confirm password are mismatch");
          this.$refs.confirmPassword.focus();
          return false;
        }
        if (this.isPasswordStrenth == false) {
          alert(
            "Weak password! Password Length Must Be 8 Characters Long.Password Must Have : 1 Digit, 1 Lower Character,1 Upper Character and 1 Special Character."
          );
          return false;
        }
        if (this.captchaValue == "") {
          alert("Please enter captcha");
          return false;
        }
        return true;
      } else {
        if (this.newPassword == null || this.newPassword == "") {
          alert("Please enter your new password");
          return false;
        } else if (
          this.newConfirmPassword == null ||
          this.newConfirmPassword == ""
        ) {
          alert("Please confirm new password");
          return false;
        } else if (this.newPassword != this.newConfirmPassword) {
          alert("Password and confirm password are mismatch");
          return false;
        } else if (this.isPasswordStrenth == false) {
          alert(
            "Weak password! Password Length Must Be 8 Characters Long.Password Must Have : 1 Digit, 1 Lower Character,1 Upper Character and 1 Special Character."
          );
          return false;
        } else if (this.captchaValueforPwd == "") {
          alert("Please enter captcha");
          return false;
        } else {
          return true;
        }
      }
    },
    validEmailOrMob(value, type) {      
      if (type == "E") {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/.test(value)) {
          return true;
        } else {
          return false;
        }
      } else {
        if (this.MobileNoCC == "+91") {
          if (/^[3456789]\d{9}$/.test(value) && value.length == 10) {
            return true;
          } else {
            return false;
          }
        } else {
          if (value.length < 21) {
            return true;
          } else {
            return false;
          }
        }
        // if (/^[456789]\d{9}$/.test(value)) {
        //   return true;
        // } else {
        //   return false;
        // }
      }
    },
    createNewUser() {
      if (!this.validateInput(1)) {
        this.generateCaptcha(1, 110, 47);
        return false;
      }
      var createLoginParam = {
        LoginID: -1,
        LoginTypeID: this.userTypeID,
        UserMobileCC: this.MobileNoCC,
        UserMobile: this.userMobile,
        UserEmail: this.userEmail,
        UserPassword: this.userPassword,
        RankID: this.titleID,
        FName: this.fName,
        MName: this.mName,
        LName: this.lName,
        Organization: this.org,
        Designation: this.desig,
        GenderID: this.gender,
        DOB: this.dob.convertToString("dd MMM yyyy"),
        Type: 1,
        CaptchaValueForPwd: this.captchaValue,
        CaptchaKeyForPwd: this.captchakey,
      };
      LoginJS.CreateNewUser(createLoginParam).then(
        (response) => {
          if (response.data[0].isSuccess) {
            alert(response.data[0].msg);
            this.isMobileOTPRequired = response.data[0].isMobileOTPRequired;
            this.isEMailOTPRequired = response.data[0].isEMailOTPRequired;
            this.verifyMobile = this.userMobile;
            this.verifyEmail = this.userEmail;
            this.hideCreateAccount();
            if (this.isMobileOTPRequired || this.isEMailOTPRequired) {
              this.isVerifyOTPReq = true;
              this.isVOTPSent = true;
              this.generateCaptcha(5, 120, 42);
              this.captchaValueForMobEmailVerification = "";
            }
          } else {
            this.generateCaptcha(1, 110, 47);
            alert(response.data[0].msg);
          }
        },
        (error) => {
          if (error.response.data.message != undefined) {
            alert(
              error.response.data.message +
                "\n" +
                error.response.data.exceptionMessage
            );
          } else {
            alert("Error: " + error.response.data);
          }
        },
        (failure) => {
          alert("Failure: " + failure.response);
        }
      );
    },
    CheckEmailOrMob(value) {
      if (this.MobileNoCC == "+91") {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/.test(value)) {
          return "E";
        } else if (/^[3456789]\d{9}$/.test(value) && value.length == 10) {
          return "M";
        } else {
          return "I";
        }
      } else {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/.test(value)) {
          return "E";
        } else if (value.length < 21) {
          return "M";
        } else {
          return "I";
        }
      }
      // if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
      //   return "E";
      // } else if (/^[456789]\d{9}$/.test(value) && value.length == 10) {
      //   return "M";
      // } else {
      //   return "I";
      // }
    },
    getOTPForVerification(e) {
      var Type = -1;
      if (
        (this.verifyMobile == null || this.verifyMobile == "") &&
        this.isMobileOTPRequired
      ) {
        FlashMessage.show(
          "<span style='color:RED'>PLEASE ENTER MOBILE NO.</span><br/>",
          2000
        );
        this.$ref.verifyMobile.focus();
        return false;
      } else if (
        this.CheckEmailOrMob(this.verifyMobile) != "M" &&
        this.isMobileOTPRequired
      ) {
        FlashMessage.show(
          "<span style='color:RED'>PLEASE ENTER VALID MOBILE NO.</span><br/>",
          2000
        );
        this.$refs.verifyMobile.focus();
        return false;
      } else if (this.verifyMobile.length != 10 && this.isMobileOTPRequired) {
        FlashMessage.show(
          "<span style='color:RED'>MOBILE NUMBER MUST BE 10 DIGITS</span><br/>",
          2000
        );
        this.$refs.verifyMobile.focus();
        return false;
      }
      if (
        (this.verifyEmail == null || this.verifyEmail == "") &&
        this.isEMailOTPRequired
      ) {
        FlashMessage.show(
          "<span style='color:RED'>PLEASE ENTER EMAIL</span><br/>",
          2000
        );
        this.$ref.verifyEmail.focus();
        return false;
      }
      if (
        this.CheckEmailOrMob(this.verifyEmail) != "E" &&
        this.isEMailOTPRequired
      ) {
        FlashMessage.show(
          "<span style='color:RED'>PLEASE ENTER VALID EMAIL</span><br/>",
          2000
        );
        this.$refs.verifyEmail.focus();
        return false;
      }
      if (this.captchaValueForMobEmailVerification == "") {
        FlashMessage.show(
          "<span style='color:RED'>PLEASE ENTER CAPTCHA</span><br/>",
          2000
        );
        this.$refs.captchaValueForMobEmailVerification.focus();
        return false;
      }
      if (this.isEMailOTPRequired && this.isMobileOTPRequired) {
        Type = 1;
      } else if (this.isMobileOTPRequired) {
        Type = 2;
      } else if (this.isEMailOTPRequired) {
        Type = 3;
      }
      const sendOTPParams = {
        LoginID: -1,
        UserMobile: this.verifyMobile,
        UserEmail: this.verifyEmail,
        type: Type,
        CaptchaValueforGetOTP: this.captchaValueForMobEmailVerification,
        CaptchakeyforGetOTP: this.captchaKeyForMobEmailVerification,
        IsOTPForForgetPass: 0,
      };
      LoginJS.GenerateLoginOTP(sendOTPParams).then(
        (result) => {
          if (result.data.isSuccess) {
            FlashMessage.show(
              "<span style='color:GREEN'>" + result.data.msg + "</span><br/>",
              3000
            );
            this.btnName = "Resend";
            this.UserID = result.data.result;
            this.isVOTPSent = true;
            this.minutesLeft = 1;
            this.secondsLeft = 59;
            this.timeLeft = true;
            this.countDownTimer();
            this.isDisabled = true;
          } else {
            FlashMessage.show(
              "<span style='color:RED'>" + result.data.msg + "</span><br/>",
              3000
            );
          }
          this.captchaValueForForgetPass = "";
          this.generateCaptcha(5, 120, 42);
        },
        (error) => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        (failure) => {
          alert("Failure: " + failure);
        }
      );
    },
    changePassword() {
      var Msg = "";
      if (this.changePassEmailMob == "") {
        Msg = "Please Enter Email/Mobile";
      } else if (this.oldPassword == "") {
        Msg = "Please Enter Old Password";
      } else if (this.newPassword == "") {
        Msg = "Please Enter New Password";
      } else if (this.newConfirmPassword == "") {
        Msg = "Please Confirm New Password";
      } else if (this.newPassword != this.newConfirmPassword) {
        Msg = "Confirm Password should be same as New Password";
      } else if (this.captchaValueForChangePass == "") {
        Msg = "Please Enter Captcha";
      }
      if (Msg != "") {
        alert(Msg);
        return false;
      }
      let param = {
        UserLoginName: this.changePassEmailMob,
        OldPassword: this.oldPassword,
        NewPassword: this.newPassword,
        captchaKey: this.captchaKeyForChangePass,
        captchaValue: this.captchaValueForChangePass,
      };
      console.log(param);
      LoginJS.changePassword(param).then(
        (result) => {
          if (result.data.isSuccess) {
            MessageBox.show({
              message: result.data.msg,
              type: "success",
              title: "Sussess",
            });
            this.changePassEmailMob = "";
            this.oldPassword = "";
            this.newPassword = "";
            this.newConfirmPassword = "";
            this.changePassworddiv = false;
            this.captchaValueForChangePass = "";
            this.captchaKeyForChangePass = "";
            this.ChangePassCaptchaID = 0;
          } else {
            this.oldPassword = "";
            this.newPassword = "";
            this.newConfirmPassword = "";
            this.captchaValueForChangePass = "";
            this.generateCaptcha(8, 120, 45);
            MessageBox.show({
              message: result.data.msg,
              type: "error",
              title: "Error",
            });
          }
        },
        (error) => {
          this.generateCaptcha(8, 120, 45);
          if (error.response == undefined) {
            FlashMessage.show(
              "<span style='color:RED'>Error: " + error + "</span><br/>",
              3000
            );
            return false;
          } else {
            FlashMessage.show(
              "<span style='color:RED'>Error: " +
                error.response.statusText +
                "</span><br/>",
              3000
            );
            return false;
          }
        },
        (failure) => {
          this.generateCaptcha(8, 120, 45);
          FlashMessage.show(
            "<span style='color:RED'>Failure: " + failure + "</span><br/>",
            3000
          );
        }
      );
    },
    getOTPForgotPass() {
      var Type = 3;
      if (
        (this.forgotMobile == null || this.forgotMobile == "") &&
        this.isMobileOTPRequired
      ) {
        alert("PLEASE ENTER MOBILE NO.");
        this.$ref.forgotMobile.focus();
        return false;
      } else if (
        this.CheckEmailOrMob(this.forgotMobile) != "M" &&
        this.isMobileOTPRequired
      ) {
        alert("PLEASE ENTER VALID MOBILE NO.");
        this.$refs.forgotMobile.focus();
        return false;
      } else if (this.forgotMobile.length != 10 && this.isMobileOTPRequired) {
        alert("Mobile number must be 10 digits");
        this.$refs.forgotMobile.focus();
        return false;
      }
      if (
        (this.forgotEmail == null || this.forgotEmail == "") &&
        this.isEMailOTPRequired
      ) {
        alert("PLEASE ENTER EMAIL");
        this.$ref.forgotEmail.focus();
        return false;
      }
      if (
        this.CheckEmailOrMob(this.forgotEmail) != "E" &&
        this.isEMailOTPRequired
      ) {
        alert("PLEASE ENTER VALID EMAIL");
        this.$refs.forgotEmail.focus();
        return false;
      }
      if (this.captchaValueForForgetPass == "") {
        alert("PLEASE ENTER CAPTCHA");
        return false;
      }
      if (this.isEMailOTPRequired && this.isMobileOTPRequired) {
        Type = 1;
      } else if (this.isMobileOTPRequired) {
        Type = 2;
      } else if (this.isEMailOTPRequired) {
        Type = 3;
      }
      const sendOTPParams = {
        LoginID: -1,
        UserMobile: this.forgotMobile,
        UserEmail: this.forgotEmail,
        type: Type,
        CaptchaValueforGetOTP: this.captchaValueForForgetPass,
        CaptchakeyforGetOTP: this.captchaKeyForForgetPass,
        IsOTPForForgetPass: 1,
      };
      LoginJS.GenerateLoginOTP(sendOTPParams).then(
        (result) => {
          if (result.data.isSuccess) {
            FlashMessage.show(
              "<span style='color:GREEN'>" + result.data.msg + "</span><br/>",
              3000
            );
            this.UserID = result.data.result;
            this.forgotOTPSend = true;
            this.minutesLeft = 1;
            this.secondsLeft = 59;
            this.timeLeft = true;
            this.countDownTimer();
            this.isDisabled = true;
          } else {
            FlashMessage.show(
              "<span style='color:RED'>" + result.data.msg + "</span><br/>",
              3000
            );
          }
          this.captchaValueForForgetPass = "";
          this.generateCaptcha(6, 120, 45);
        },
        (error) => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        (failure) => {
          alert("Failure: " + failure);
        }
      );
    },
    sendOTP() {
      var email = "";
      var mob = "";
      var type = -1;
      if (this.CheckEmailOrMob(this.loginName) == "E") {
        if (this.loginName == "") {
          FlashMessage.show(
            "<span style='color:RED'>PLEASE ENTER EMAIL</span><br/>",
            3000
          );
          return;
        }
        if (this.loginName.length < 10) {
          FlashMessage.show(
            "<span style='color:RED'>PLEASE ENTER VALID EMAIL</span><br/>",
            3000
          );
          return;
        }
        if (!this.isEMailOTPRequired) {
          FlashMessage.show(
            "<span style='color:RED'>Sending OTP on EMAIL is not allowed.</span><br/>",
            3000
          );
          return;
        }
        email = this.loginName;
        mob = "";
        type = 3;
      } else if (this.CheckEmailOrMob(this.loginName) == "M") {
        if (this.loginName == "") {
          FlashMessage.show(
            "<span style='color:RED'>PLEASE ENTER MOBILE NUMBER</span><br/>",
            3000
          );
          return;
        }
        if (this.loginName.length < 10) {
          FlashMessage.show(
            "<span style='color:RED'>PLEASE ENTER VALID MOBILE NUMBER</span><br/>",
            3000
          );
          return;
        }
        if (!this.isMobileOTPRequired) {
          FlashMessage.show(
            "<span style='color:RED'>Sending OTP on MOBILE is not allowed.</span><br/>",
            3000
          );
          return;
        }
        email = "";
        mob = this.loginName;
        type = 2;
      } else {
        FlashMessage.show(
          "<span style='color:RED'>PLEASE ENTER VALID MOBILE OR EMAIL</span><br/>",
          3000
        );
        return;
      }
      if (this.captchaValueforGetOTP == "") {
        FlashMessage.show(
          "<span style='color:RED'>PLEASE ENTER CAPTCHA</span><br/>",
          3000
        );
        return;
      }
      const sendOTPParams = {
        LoginID: -1,
        UserMobile: mob,
        UserEmail: email,
        type: type,
        CaptchaValueforGetOTP: this.captchaValueforGetOTP,
        CaptchakeyforGetOTP: this.captchakeyforGetOTP,
        IsOTPForForgetPass: 0,
      };
      // var formData = new FormData();
      // formData.append("SendOTPParams", JSON.stringify(sendOTPParams));
      LoginJS.GenerateLoginOTP(sendOTPParams).then(
        (result) => {
          //console.log(result.data);
          if (result.data.isSuccess) {
            FlashMessage.show(
              "<span style='color:GREEN'>" + result.data.msg + "</span><br/>",
              3000
            );
            this.UserID = result.data.result;
            this.minutesLeft = 1;
            this.secondsLeft = 59;
            this.timeLeft = true;
            this.countDownTimer();
            this.isDisabled = true;
            this.loginTypeID = 2;
            vue.nextTick(() => {
              document.getElementById("txtOTP").focus();
            });
          } else {
            this.captchaValueforGetOTP = "";
            this.generateCaptcha(3, 100, 17);
            FlashMessage.show(
              "<span style='color:RED'>" + result.data.msg + "</span><br/>",
              3000
            );
          }
        },
        (error) => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        (failure) => {
          alert("Failure: " + failure);
        }
      );
    },
    countDownTimer() {
      if (this.timeLeft) {
        setTimeout(() => {
          if (this.secondsLeft > 0) {
            this.secondsLeft--;
          } else if (this.secondsLeft == 0 && this.minutesLeft >= 0) {
            this.secondsLeft = 59;
            this.minutesLeft--;
          }
          if (this.minutesLeft < 0) {
            this.secondsLeft = 0;
            this.minutesLeft = 0;
            this.timeLeft = false;
          }
          this.countDownTimer();
        }, 1000);
      } else {
        if (this.loginTypeID == 2) {
          this.OtpCaptchaID = 1;
          this.generateCaptcha(4, 80, 18);
        }
        this.isDisabled = false;
      }
    },
    changePasswordView() {
      this.ChangePassCaptchaID = 1;
      this.changePassworddiv = true;
      this.captchaValueForChangePass = "";
      this.generateCaptcha(8, 120, 45);
      this.createNewAccountdiv = false;
      this.hideBg = true;
    },
    forgetPasswordView() {
      this.forgotPassworddiv = true;
      this.OtpForgetPassCaptchaID = 1;
      this.captchaValueForForgetPass = "";
      this.generateCaptcha(6, 120, 45);
      this.createNewAccountdiv = false;
      this.hideBg = true;
    },
    verifyForgotPasswordAuth() {
      /*
      if (this.forgotLogin == null || this.forgotLogin == "") {
        alert("Please enter your email");
        this.$ref.forgotLogin.focus();
        return false;
      } else if (this.forgotMobile == null || this.forgotMobile == "") {
        alert("Please enter your mobile number");
        this.$ref.forgotMobile.focus();
        return false;
      }
      */

      let userEMail = this.forgotLogin.trim();
      let userMobile = this.forgotMobile.trim();
      let _paramsData = {
        userEMail: userEMail,
        userMobile: userMobile,
        captchaValueForForgetPass: this.captchaValueForForgetPass,
        captchaKeyForForgetPass: this.captchaKeyForForgetPass,
      };
      LoginJS.GetForgetUser(_paramsData).then(
        (response) => {
          //console.log(response.data);
          if (response.data.isSuccess) {
            this.UserID = response.data.result.userID;
            this.forgotOTPSend = true;
            this.minutesLeft = 1;
            this.secondsLeft = 59;
            this.timeLeft = true;
            this.countDownTimer();
            this.verifyCredential = "Resend OTP";
            this.isDisabled = true;
            this.OtpCaptchaID = 1;
            this.eMailOTPRef = response.data.result.emailOTPRef;
            this.mobileOTPRef = response.data.result.mobileOTPRef;
            this.captchaValueForForgetPass = "";
            this.generateCaptcha(6, 120, 45);
          } else {
            this.captchaValueForForgetPass = "";
            this.generateCaptcha(6, 120, 45);
          }
          alert(response.data.msg);
        },
        (error) => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        (failure) => {
          alert("Failure: " + failure);
        }
      );
    },
    verifyOTP(type) {
      let userEMail = "";
      let userMobile = "";
      let eMailOTP = "";
      let mobileOTP = "";
      if (type == 1) {
        userEMail = this.isEMailOTPRequired == 1 ? this.verifyEmail.trim() : "";
        eMailOTP = this.isEMailOTPRequired == true ? this.emailOTP.trim() : "";
        userMobile =
          this.isMobileOTPRequired == 1 ? this.verifyMobile.trim() : "";
        mobileOTP = this.isMobileOTPRequired == 1 ? this.mobileOTP.trim() : "";
        if (this.isEMailOTPRequired) {
          if (userEMail == "") {
            FlashMessage.show(
              "<span style='color:RED'>PLEASE ENTER EMAIL</span><br/>",
              3000
            );
            return false;
          }
          if (eMailOTP == "") {
            FlashMessage.show(
              "<span style='color:RED'>PLEASE ENTER EMAIL OTP</span><br/>",
              3000
            );
            return false;
          }
        }
        if (this.isMobileOTPRequired == 1) {
          if (userMobile == "") {
            FlashMessage.show(
              "<span style='color:RED'>PLEASE ENTER MOBILE NO.</span><br/>",
              3000
            );
            return false;
          }
          if (mobileOTP == "") {
            FlashMessage.show(
              "<span style='color:RED'>PLEASE ENTER MOBILE OTP</span><br/>",
              3000
            );
            return false;
          }
        }
      }
      if (type == 2) {
        userEMail = this.isEMailOTPRequired == 1 ? this.forgotEmail.trim() : "";
        eMailOTP =
          this.isEMailOTPRequired == 1 ? this.forgotEmailOTP.trim() : "";
        userMobile =
          this.isMobileOTPRequired == 1 ? this.forgotMobile.trim() : "";
        mobileOTP =
          this.isMobileOTPRequired == 1 ? this.forgotMobOTP.trim() : "";

        if (this.isEMailOTPRequired == 1) {
          if (userEMail == "") {
            FlashMessage.show(
              "<span style='color:RED'>PLEASE ENTER EMAIL</span><br/>",
              3000
            );
            return false;
          }
          if (eMailOTP == "") {
            FlashMessage.show(
              "<span style='color:RED'>PLEASE ENTER EMAIL OTP</span><br/>",
              3000
            );
            return false;
          }
        }
        if (this.isMobileOTPRequired == 1) {
          if (userMobile == "") {
            FlashMessage.show(
              "<span style='color:RED'>PLEASE ENTER MOBILE NO.</span><br/>",
              3000
            );
            return false;
          }
          if (mobileOTP == "") {
            FlashMessage.show(
              "<span style='color:RED'>PLEASE ENTER MOBILE OTP</span><br/>",
              3000
            );
            return false;
          }
        }
      }
      let _paramsData = {
        userEMail: userEMail,
        isEmailOTPReq: this.isEMailOTPRequired,
        isMobileOTPReq: this.isMobileOTPRequired,
        userMobile: userMobile,
        eMailOTP: eMailOTP,
        mobileOTP: mobileOTP,
        type: type,
      };
      LoginJS.OTPVerification(_paramsData).then(
        (response) => {
          alert(response.data.msg);
          if (response.data.isSuccess) {
            this.eMailOTPRef = "";
            this.mobileOTPRef = "";
            if (type == 1) {
              this.isVerifyOTPReq = false;
              this.hideCreateAccount();
            } else {
              this.forgotVerification = true;
              this.generateCaptcha(2, 120, 45);
            }
            this.OtpCaptchaID = 0;
          }
        },
        (error) => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        (failure) => {
          alert("Failure: " + failure);
        }
      );
    },
    setNewPassword() {
      if (this.newPassword == "") {
        FlashMessage.show(
          "<span style='color:RED'>PLEASE ENTER NEW PASSWORD</span><br/>",
          3000
        );
        return false;
      }
      if (this.newConfirmPassword == "") {
        FlashMessage.show(
          "<span style='color:RED'>PLEASE ENTER NEW PASSWORD</span><br/>",
          3000
        );
        return false;
      }
      if (this.newConfirmPassword != this.newPassword) {
        FlashMessage.show(
          "<span style='color:RED'>PASSWORD NOT MATCHED</span><br/>",
          3000
        );
        return false;
      }
      if (this.captchaValueforPwd == "") {
        this.generateCaptcha(2, 120, 45);
        this.captchaValueforPwd = "";
        FlashMessage.show(
          "<span style='color:RED'>PLEASE ENTER CAPTCHA</span><br/>",
          3000
        );
        return false;
      }
      this.forgotEmail =
        this.forgotEmail != "" ? this.forgotEmail.trim() : "''";
      this.forgotMobile =
        this.forgotMobile != "" ? this.forgotMobile.trim() : "''";
      let _paramsData = {
        loginID: this.UserID,
        userEMail: this.forgotEmail,
        userMobile: this.forgotMobile,
        newPassword: this.newPassword,
        captchaKey: this.captchakeyforPwd,
        captchaValue: this.captchaValueforPwd,
      };
      LoginJS.ResetPasswordOnline(_paramsData).then(
        (response) => {
          if (response.data.isSuccess) {
            FlashMessage.show(
              "<span style='color:GREEN'>Password has been changed. Please Login with new Password.</span><br/>",
              3000
            );
            this.forgotPassworddiv = false;
          } else {
            this.captchaValueforPwd = "";
            this.generateCaptcha(2, 120, 45);
            FlashMessage.show(
              "<span style='color:RED'>" + response.data.msg + "</span><br/>",
              3000
            );
          }
        },
        (error) => {
          if (error.response == undefined) {
            FlashMessage.show(
              "<span style='color:RED'>Error: " + error + "</span><br/>",
              3000
            );
            return false;
          } else {
            FlashMessage.show(
              "<span style='color:RED'>Error: " +
                error.response.statusText +
                "</span><br/>",
              3000
            );
            return false;
          }
        },
        (failure) => {
          FlashMessage.show(
            "<span style='color:RED'>Failure: " + failure + "</span><br/>",
            3000
          );
          return false;
        }
      );
    },
  },
  mounted() {
    // this.generateCaptcha(4, 80, 18);
    if (this.$root.$data.sessionPage != undefined) {
      this.$router.go();
    }
    window.sessionStorage.removeItem("token");
    window.sessionStorage.removeItem("token_type");
    window.sessionStorage.removeItem("refresh_token");
    window.sessionStorage.removeItem("antiforgery_token");

    ekkJS.setDateControls();
    this.checkBrowserVersion(
      document.getElementById("divBrowserInfo"),
      document.getElementById("divBrowserNotSupported")
    );
    this.GetSetupData();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Login.vue